import { useState, useEffect, useRef } from 'react';
import { ethers } from 'ethers';
import { useWallet } from '../context/WalletContext';
import { useContracts } from './useContract';
import { CONTRACTS } from '../config/contracts';

export const useUsdtBalance = () => {
  const { account } = useWallet();
  const { usdt } = useContracts();

  const [balance, setBalance] = useState(ethers.BigNumber.from(0));
  const [allowance, setAllowance] = useState(ethers.BigNumber.from(0));
  const [loading, setLoading] = useState(false);

  const runIdRef = useRef(0);

  const load = async () => {
    if (!account || !usdt) return;
    const myRun = ++runIdRef.current;
    setLoading(true);
    try {
      const [bal, allow] = await Promise.all([
        usdt.balanceOf(account),
        usdt.allowance(account, CONTRACTS.GlobalStorage)
      ]);
      if (myRun !== runIdRef.current) return;
      setBalance(bal);
      setAllowance(allow);
    } catch (_) { /* ignore */ }
    finally {
      if (myRun === runIdRef.current) setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [account]);

  return { balance, allowance, loading, refresh: load };
};
